import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { useQueryParam } from "../../utils/useQueryParams";
import { requestHttp } from "../../utils/httpClient";

const AUTH_STATE = {
  CHECKING: 0,
  VALID: 1,
  FORBIDDEN: 2,
};

export const AuthPage = () => {
  const navigate = useNavigate();

  let [user, setUser] = useQueryParam("user");
  let [tokenReport, setTokenReport] = useQueryParam("tokenr");
  const [authCheck, setAuthCheck] = useState(AUTH_STATE.CHECKING);

  useEffect(() => {
    const callRequestAuth = () => {
      setTimeout(() => {
        requestAuth();
      }, 2000);
    }
    callRequestAuth();
  }, []);

  const requestAuth = async () => {
    try {
      const response = await requestHttp({
        endpoint: "/auth/validate",
        data: {
          user,
          token_report: tokenReport,
        },
        isAuth: true,
      });
      localStorage.setItem("_SESSION_REPORT_", response.data.token);
      navigate(response.data.path);
    } catch (err) {
      setAuthCheck(AUTH_STATE.FORBIDDEN);
    }
  };

  if (authCheck === AUTH_STATE.CHECKING) {
    return (
      <Box
        sx={{
          height: 300,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (authCheck === AUTH_STATE.FORBIDDEN) {
    return (
      <Box
        sx={{
          height: 300,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DoDisturbIcon sx={{ color: red[500] }} />
        <Typography variant="body1">Acceso no permitido</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="body1">Redireccionando...</Typography>
    </Box>
  );
};
